import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs/Subscription";
import { MasterService } from "../../../shared/services/master.service";
import { DataService } from "../../../shared/services/data.service";
import { Router } from "@angular/router";
// import {CustomValidators} from '../../../shared/validators/custom.validators';
import { SensorModel } from "../../../shared/models/sensor.model";
import { SensorsService } from "../../../shared/services/sensors.service";
import { RemoteCaptivePortalModel } from "../../../shared/models/remote-captive-portal.modal";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserSitesSelectionComponent } from "../../users/user-sites-selection/user-sites-selection.component";
import { SiteModel } from "../../../shared/models/site.model";
import { SensorRemoteCommandModel } from "../../../shared/models/sensor-remote-command.model";
interface LandingPageParams {
  domain: string;
  siteId: number;
  userName?: string;
  password?: string;
  visitorId?: string;
}

@Component({
  selector: "lba-captive-portal",
  templateUrl: "./captive-portal.component.html",
  styleUrls: ["./captive-portal.component.scss"],
})
export class CaptivePortalComponent implements OnInit, OnDestroy {
  form: FormGroup;
  siteTitle: string = "Select site";
  sensor: SensorModel = this.dataService.selectedSensor;
  captivePortal: RemoteCaptivePortalModel;
  internet: boolean = false;
  // encryption: string[] = ['wpa2', 'open'];
  encryptionType = [
    { value: "wpa2", label: "WPA2" },
    { value: "open", label: "Open" },
  ];
  encryption = "OPEN";
  interfaces = [
    { value: "lan", label: "LAN", checked: true },
    { value: "lte", label: "LTE" },
  ];
  interface = "LAN";
  internetAccess = [
    { value: "true", label: "Yes" },
    { value: "false", label: "No" },
  ];
  subscription: Subscription;
  location: any;

  ssid: string = null;
  domain: string = "";
  siteId: number = null;
  username: string = "";
  userPassword: string = "";
  visitorId: string = "";
  landingPageDetails: string = "Show Landing page setting";
  dropdownTitle: string = "Choose parameter";
  password: string = "";

  selection = [
    { value: "ssid", label: "SSID" },
    { value: "landingPage", label: "Landing Page" },
  ];

  item: string = "";
  isSsid: boolean = false;
  isDomain: boolean = false;
  isInternet: boolean = false;
  isEncryption: boolean = false;
  isInterface: boolean = false;
  isLandingPage: boolean = false;
  isExpand: boolean = false;

  constructor(
    private modalService: NgbModal,
    private masterService: MasterService,
    private sensorService: SensorsService,
    private dataService: DataService,
    private router: Router,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.configureUI();

    // this.subscription = this.serversService.getServers().subscribe((servers: ServerModel[]) => {
    //     this.servers = servers.filter(
    //       status => status.deploymentStatus > 0);
    //   // this.servers = servers;
    //   console.log(this.servers);
    //   const server = this.serversService.getServerFromId(this.sensor.serverId, servers);
    //   if (server) {
    //     this.serverName = server.name;
    //     this.serverId = server.id;
    //   } else {
    //     this.serverId = this.sensor.serverId;
    //   }
    // },
    //   error => {
    //     console.log(error);
    //     window.alert('Error: ' + error.message + ', error status: ' + error.status);
    //   });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // Private methods

  configureUI() {
    this.form = new FormGroup({
      // ssid: new FormControl(null),
      domain: new FormControl(null),
      siteId: new FormControl(null),
      username: new FormControl(null),
      userpassword: new FormControl(null),
      // visitorId: new FormControl(null),
      // internet: new FormControl(null),
      // encryption: new FormControl(null),
      // password: new FormControl(null),
      // interface: new FormControl(null),
    });

    this.updateValues();
  }

  updateValues() {
    if (this.sensor != null || this.sensor === undefined) {
      this.form.setValue({
        // ssid: this.ssid,
        domain: this.domain,
        siteId: this.siteId,
        username: this.username,
        userpassword: this.userPassword,
        // visitorId: this.visitorId,
        // internet: this.internet,
        // encryption: this.encryption,
        // userpassword: this.userPassword,
        // password: this.password,
        // interface: this.interface,
      });
    }
  }

  submit() {
    const formData = this.form.value;
    // console.log('FormData' , formData, this.item);

    this.domain = formData.domain.trim();
    this.siteId = formData.siteId.trim();
    this.username = formData.username;
    this.userPassword = formData.userpassword;
  //  this.visitorId = formData.visitorId;
    // console.log('domain submit-> ', this.domain),
    // console.log('siteId submit-> ', this.siteId),
    // console.log('username submit-> ', this.username),
    // console.log('userpassword submit-> ', this.userPassword),
    // console.log('visitorId submit-> ', this.visitorId),
    this.changeLandingPage();

    // if (this.item !== '') {
    //   switch (this.item) {
    //     case 'SSID':
    //       this.ssid = formData.ssid;
    //       // console.log('ssid submit-> ', this.ssid),
    //       this.setSsid();
    //       break;

    //     case 'Landing Page':
    //       this.domain = formData.domain;
    //       this.siteId = formData.siteId;
    //       this.username = formData.username;
    //       this.userPassword = formData.userpassword;
    //     //  this.visitorId = formData.visitorId;
    //       console.log('domain submit-> ', this.domain),
    //       console.log('siteId submit-> ', this.siteId),
    //       console.log('username submit-> ', this.username),
    //       console.log('userpassword submit-> ', this.userPassword),
    //       // console.log('visitorId submit-> ', this.visitorId),
    //       this.changeLandingPage();
    //       break;

    //     // case 'Internet Access':
    //     //   this.internet = formData.internet;
    //     //   // console.log('intenet submit-> ', this.internet),
    //     //   this.changeInternet();
    //     //   break;

    //     // case 'Encryption':
    //     // // if wpa2, put password*********
    //     //   this.encryption = formData.encryption;
    //     //   if (this.encryption === 'WPA2') this.password = formData.password;
    //     //   // console.log('encryption submit-> ', this.encryption, '\npassword submit -> ', this.password);
    //     //   this.changeEncryption();
    //     //   break;

    //     // case 'Interface':
    //     //   this.interface = formData.interface;
    //     //   // console.log('interface submit-> ', this.interface);
    //     //   this.changeInterface();
    //     //   break;

    //     default:
    //       break;
    //   }
    //   // this.location.back();
    // }
  }

  onChooseItem(item: any) {
    // console.log('Choose--> ', item);
    this.item = item;
    // for (let i = 0; i < this.selection.length; i++) {
    //   if (item.toLowerCase() !== this.selection.values) {
    //   }

    // }
    // this.onClickDropdown();
    this.isExpand = true;
    this.onClickDropdown();
    switch (item) {
      case "SSID":
        this.isSsid = true;
        this.isLandingPage = false;
        this.isInternet = false;
        this.isEncryption = false;
        this.isInterface = false;
        break;

      case "Landing Page":
        this.isLandingPage = true;
        this.isSsid = false;
        this.isInternet = false;
        this.isEncryption = false;
        this.isInterface = false;
        break;

      //   case 'Internet Access':
      //     this.isInternet = true; // !this.isInternet;
      //     this.isLandingPage = false;
      //     this.isSsid = false;
      //  //   this.isEncryption = false;
      //     this.isInterface = false;
      //     break;

      //   case 'Encryption':
      //     this.isEncryption = true;
      //     this.isSsid = false;
      //     this.isLandingPage = false;
      //     this.isInternet = false;
      //     this.isInterface = false;
      //     break;

      //   case 'Interface':
      //     this.isInterface = true;
      //     this.isSsid = false;
      //     this.isLandingPage = false;
      //     this.isInternet = false;
      //   this.isEncryption = false;
      // break;

      default:
        break;
    }
  }

  //   changeInterface() {
  //     // console.log('interface::',  this.interface);
  //     this.sensorService.setInterface(this.sensor.id, this.interface)
  //         .subscribe(
  //           (newSensor: SensorRemoteCommandModel) => {
  //             window.alert('Changing Interface.');
  //             this.closeModal();
  //           },
  //           error => {
  //             console.log(error);
  //             window.alert('Error!!');
  //           },
  //           () => {},
  //           );
  // }
  //   changeEncryption() {
  //     // console.log('encryption type::::', this.encryption)
  //     if (this.encryption === 'Open') {
  //       this.sensorService.setEncryption(this.sensor.id, this.encryption)
  //       .subscribe(
  //         (newSensor: SensorRemoteCommandModel) => {
  //           window.alert('Changing Encryption.');
  //           this.closeModal();
  //         },
  //         error => {
  //           console.log(error);
  //           window.alert('Error!!');
  //         },
  //         () => {},
  //         );
  //     } else if (this.encryption === 'WPA2') {
  //       // console.log('password: ', this.password);
  //       this.sensorService.setEncryption(this.sensor.id, this.encryption, this.password)
  //         .subscribe(
  //           (newSensor: SensorRemoteCommandModel) => {
  //             window.alert('Changing Encryption.');
  //           },
  //           error => {
  //             console.log(error);
  //             window.alert('Error!!');
  //           },
  //           () => {},
  //           );
  //     }

  //   }
  //   changeInternet() {
  //     // console.log('changing internet access to ', this.internet);
  //     this.sensorService.setInternetAccess(this.sensor.id, this.internet.toString())
  //         .subscribe(
  //           (newSensor: SensorRemoteCommandModel) => {
  //             window.alert('Changing Internet access: ' + this.internet.toString());
  //             this.closeModal();
  //          //   (<HTMLInputElement> document.getElementById('rebootSensor')).disabled = true;
  //           },
  //           error => {
  //             console.log(error);
  //             window.alert('Error!!');
  //           //  (<HTMLInputElement> document.getElementById('rebootSensor')).disabled = true;
  //           },
  //           () => {},
  //           );
  //   }
  changeLandingPage() {
    console.log('username: ', this.username);
    console.log('password: ', this.userPassword);
    // tslint:disable-next-line: max-line-length
    let domain = this.domain;
    if ( domain !== null && !domain.includes("https://")) {
      domain = "https://" + this.domain;
    }
    if (domain !== null && this.siteId !== null && this.username !== null && this.userPassword !== null)
    this.sensorService
      .setLandingPage(
        this.sensor.id,
        domain,
        this.siteId,
        this.username,
        this.userPassword,
      )
      .subscribe(
        (newSensor: SensorRemoteCommandModel) => {
          window.alert("Changing Landing Page.");
          this.closeModal();
        },
        (error) => {
          console.log(error);
          window.alert("Error!!");
        },
        () => {}
      );
  }

  // onChooseEncryption(encryption: any) {
  //   const formData = this.form.value;
  //   formData.encryption = encryption;
  //  // this.encryption = formData.en;
  //   // console.log('encryption: ', this.encryption);
  // }

  // onChooseInterface(intf: any) {
  //   this.interface = intf;
  // }

  // onChooseInternet(internet: boolean) {
  //   // console.log('internet-> ', this.internet);
  //   if (internet !== null || internet !== undefined) {
  //     this.internet = internet;
  //  //   this.changeInternet();
  //   }
  // }
  onClickLandingPage() {
    this.isLandingPage = !this.isLandingPage;
    if (this.isLandingPage === true) {
      this.landingPageDetails = "Landing page setting";
    } else {
      this.landingPageDetails = "Show landing page setting ";
    }
  }

  // setSsid() {
  //   // this.dialogService.open(NbDialogService).onClose.subscribe(ssid => this.ssid);
  //   this.sensorService.setSsid(this.sensor.id, this.ssid).subscribe(
  //     (newSensor: SensorModel) => {
  //       window.alert("Changing SSID.");
  //       this.closeModal();
  //       //   (<HTMLInputElement> document.getElementById('rebootSensor')).disabled = true;
  //     },
  //     (error) => {
  //       console.log(error);
  //       window.alert("Error!!");
  //       //  (<HTMLInputElement> document.getElementById('rebootSensor')).disabled = true;
  //     },
  //     () => {}
  //   );
  //   // console.log('ssid---->', this.ssid);
  // }
  onClickDropdown() {
    // this.isExpand = !this.isExpand;
    if (this.isExpand === true) {
      this.dropdownTitle = this.item;
    } else {
      this.dropdownTitle = "Choose Parameter";
    }
  }
  cancel() {
    this.closeModal();
    // this.location.back(); // <-- go back to previous location on cancel
  }
  closeModal() {
    this.activeModal.close();
  }
}
